const traitsOrder = [
  'gender',
  'age',
  'age_range',
  'income',
  'education_level',
  'ethnicity',
  'employment',
  'career',
  'relationship_status',
  'children',
  'country',
  'state',
  'county',
  'msa',
  'state_region',
  'region',
  'zip'
]

export const convertQuotas = (survey = []) => {
  const target_market = survey.target_market || {}
  const quotas = target_market.quotas || []

  return Array.isArray(survey.traits || [])
    ? quotas
    : quotas
        .map(q => {
          const _q = JSON.parse(JSON.stringify(q))
          if (Object.hasOwn(q, 'balancing')) {
            _q.balancing.traits = (_q.balancing.order || []).map(id => {
              const trait = _q.balancing.values[id]
              const key = id.replace('ask_', '')
              if ('age' === key && _q.balancing.order.includes('age_range')) return null

              return {
                id: key,
                label: key,
                text: key,
                type: ('age' === key && 'n') || 't',
                values: Object.keys(trait || {})
                  .sort()
                  .reduce((acc, cur) => {
                    acc.push({ text: cur, value: trait[cur].toFixed(2) })
                    return acc
                  }, []),
                filtered: false
              }
            })
          }
          if (Object.hasOwn(q, 'traits')) {
            _q.traits = (_q.traits.order || []).map(id => {
              const trait = _q.traits.values[id]
              const key = id.replace('ask_', '')
              if ('age' === key && _q.traits.order.includes('age_range')) return null

              return {
                id: key,
                label: trait.label,
                text: trait.text,
                type: ('age' === key && 'n') || 't',
                values: trait.values || [],
                filtered: trait.filtered
              }
            })
          }
          return _q
        })
        .filter(v => null !== v)
}

export const convertTraits = (survey = {}) => {
  const traits = Array.isArray(survey.traits || [])
    ? (survey.traits || [])
        .filter(t => 'trait_var' === t.kind && t.values != undefined && 0 < t.values.length)
        .reduce((acc, cur) => {
          if (
            'age' === cur.id &&
            survey.traits.some(
              t => 'age_range' === t.id && 'trait_var' === t.kind && t.values != undefined && 0 < t.values.length
            )
          )
            return acc

          const id = ('age' === cur.id && 'age_range') || cur.id
          const type = ('age' === cur.id && 't') || cur.type

          const index = acc.findIndex(t => id == t.id)
          if (0 > index) {
            const trait = {
              id,
              title:
                (cur.title &&
                  ((survey.locale && (cur.title[survey.locale] || cur.title[survey.locale.split('_')[0]])) ||
                    cur.title.en ||
                    cur.title)) ||
                cur.id,
              type: type,
              values: cur.values.map(function (_v) {
                _v.name =
                  (_v.name &&
                    ((survey.locale && (_v.name[survey.locale] || _v.name[survey.locale.split('_')[0]])) ||
                      _v.name.en ||
                      _v.name)) ||
                  _v.id
                return _v
              })
            }
            if (Object.hasOwn(cur, 'missing')) {
              trait.missing = cur.missing
            }
            acc.push(trait)
          } else {
            if ('a' == type) acc[index].type = 'a'
            acc[index].values = acc[index].values
              .concat(
                cur.values.map(function (_v) {
                  _v.name =
                    (_v.name &&
                      ((survey.locale && (_v.name[survey.locale] || _v.name[survey.locale.split('_')[0]])) ||
                        _v.name.en ||
                        _v.name)) ||
                    _v.id
                  return _v
                })
              )
              .filter((v, i, a) => i == a.findIndex(t => t.id == v.id))
          }
          return acc
        }, [])
    : traitsOrder.reduce((acc, cur) => {
        const trait = survey.traits[cur]
        if (trait == undefined || trait.sortOrder == undefined || !trait.sortOrder.length) return acc

        if ('state_region' === cur) {
          acc.push({
            id: 'region',
            title: 'Regions',
            type: 't',
            values: trait.sortOrder
              .filter(v => 'R' === v[0])
              .map(v => {
                return {
                  id: v.slice(2),
                  name: trait.names[v] || v.slice(2)
                }
              })
          })
          acc.push({
            id: 'state',
            title: 'States',
            type: 't',
            values: trait.sortOrder
              .filter(v => 'S' === v[0])
              .map(v => {
                return {
                  id: v.slice(2),
                  name: trait.singularNames[v] || trait.names[v] || v.slice(2)
                }
              })
          })
        } else {
          const key = cur.replace('ask_', '')
          if ('age' === key && survey.traits['age_range'] != undefined) return acc

          acc.push({
            id: ('age' === key && 'age_range') || key,
            title: trait.name || key,
            type: 't',
            values: trait.sortOrder.map(v => {
              return {
                id: ('age' === key && trait.names[v]) || v,
                name: trait.singularNames[v] || trait.names[v] || v
              }
            })
          })
        }

        return acc
      }, [])

  const quotas = convertQuotas(survey)

  const isExternalSurvey = 'Survey' !== survey.class

  return traits.filter(
    trait =>
      null !== trait &&
      ('age' !== trait.id || ('age' === trait.id && !traits.some(t => 'age_range' === t.id))) &&
      !('children' === trait.id && 1 == (survey.target_market || {}).version) &&
      !(
        isExternalSurvey &&
        quotas[0] &&
        quotas[0].traits &&
        !quotas[0].traits.some(t => trait.id == t.id && t.filtered)
      )
  )
}
